import { render, staticRenderFns } from "./EmploymentFields.vue?vue&type=template&id=08d34f6e"
import script from "./EmploymentFields.vue?vue&type=script&lang=js"
export * from "./EmploymentFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports